import gql from "graphql-tag";
import { doQuery } from "../../core-module/util/graphqlHelper";

export const getLoginAudits = ({ status = "ALL", search = "", page = 1, limit = 20 } = {}) => {
  const query = gql`
    query GetLoginAudits($status: String, $search: String, $page: Int, $limit: Int) {
      getLoginAudits(status: $status, search: $search, page: $page, limit: $limit) {
        items {
          id
          userId
          userName
          userRole
          attemptedEmail
          status
          failureReason
          ipAddress
          country
          city
          browser
          os
          deviceId
          createdAt
        }
        stats {
          totalAttempts
          totalSuccess
          totalFailed
          uniqueIps
        }
        totalCount
        page
        limit
        totalPages
      }
    }
  `;
  return doQuery({
    query,
    variables: { status, search, page, limit },
    fetchPolicy: "network-only",
  }).then(({ data, error }) => {
    if (data) return { data: data.getLoginAudits };
    return { error };
  });
};
